import {
  isTradeWorkbenchInterval,
  type MarketDefinitionT,
  type TradeWorkbenchIntervalT,
} from '@web/routes/trade/-workstation/types';

const STORAGE_KEY = 'hypersense:chart-interval';

export function readPersistedChartInterval(
  market: MarketDefinitionT,
): TradeWorkbenchIntervalT {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (
      isTradeWorkbenchInterval(stored) &&
      market.supportedChartIntervals.includes(stored)
    ) {
      return stored;
    }
  } catch {}

  return market.defaultChartInterval;
}

export function persistChartInterval(interval: TradeWorkbenchIntervalT): void {
  try {
    localStorage.setItem(STORAGE_KEY, interval);
  } catch {}
}
